module.exports = __webpack_public_path__ + "img/donante-cecati.d8d0d406.png";